import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { ModalSelectEvent } from '../services-calendar/components/modal-select-event';
import { useServiceData } from '../../views/Calendar/hooks/useServiceData';

export const ModalServiceData = ({ show, serviceId, handleClose, handleEditService, handleCancelService }) => {
  const [eventData, setEventData] = useState(null);
  const { serviceData } = useServiceData({ serviceId });

  useEffect(() => {
    if (!show || !serviceData) {
      setEventData(null);
      return;
    }
    setEventData({
      id: serviceData._id,
      start: serviceData.start,
      confirmedByUser: serviceData.confirmedByUser,
      confirmedByFinalCustomer: serviceData.confirmedByFinalCustomer,
      assignedFinalCustomer: serviceData.idFinalCustomer,
      assignedServiceType: serviceData.idTypeService?.name,
      assignedUser: serviceData.idUser?.profile?.name,
      title: serviceData.title,
      privateId: serviceData.privateId,
      data: {
        extendedFormData: serviceData.extendedFormData,
        start: serviceData.start,
        infoAssignedCompany: serviceData.idAssignedCompany,
        infoServiceType: serviceData.idTypeService,
        status: serviceData.status,
        infoFinalCustomer: {
          phone: serviceData.idFinalCustomer?.phone,
          mobilePhone: serviceData.idFinalCustomer?.mobilePhone,
        },
        infoAsset: serviceData.idAsset?.name ? { name: serviceData.idAsset.name } : null,
      },
    });
  }, [show, serviceData]);

  return (
    <>
      {show && serviceId && eventData ? (
        <ModalSelectEvent
          show={show}
          handleClose={handleClose}
          event={eventData}
          editEvent={handleEditService}
          onCancelEvent={handleCancelService}
        />
      ) : null}
    </>
  );
};

ModalServiceData.propTypes = {
  show: PropTypes.bool,
  serviceId: PropTypes.string,
  handleClose: PropTypes.func,
  handleEditService: PropTypes.func,
  handleCancelService: PropTypes.func,
};
